import { render, staticRenderFns } from "./CarCategory.vue?vue&type=template&id=2e11ab84&scoped=true&"
import script from "./CarCategory.vue?vue&type=script&lang=js&"
export * from "./CarCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e11ab84",
  null
  
)

export default component.exports